import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Col, Row, Container, Card, CardBody } from "reactstrap"
import backend from "api/api"
import SearchTable from "components/SearchTable/searchTable"
import { useDispatch, useSelector } from "react-redux"
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt"
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined"
import { Link } from "react-router-dom"
import { Box, CircularProgress, Grid, Tooltip, Typography } from "@mui/material"
import servicesIcon1 from "assets/images/services-icon/01.png"
import servicesIcon2 from "assets/images/services-icon/02.png"
import servicesIcon3 from "assets/images/services-icon/03.png"
import servicesIcon4 from "assets/images/services-icon/04.png"
import capture from "./capture.png"
import Not from "./Not.png"
import { toast, ToastContainer } from "react-toastify"
import PropTypes from "prop-types"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}

export default function Review() {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const [value, setValue] = React.useState(0)
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  let rows = []
  const getAllReview = async () => {
    try {
      setLoading(true)
      const resp = await backend.get("/api/review")
      setLoading(false)
      dispatch({
        type: "REVIEW_SUCCESS",
        payload: resp.data.data,
      })
    } catch (error) {
      toast.error(error?.response?.data.message || error?.message || error)
    }
  }
  const { review } = useSelector(state => state.ReviewReducer)
  const ActiveReview = review.filter(e => e?.status === "active")
  const notGivenReview = review.filter(e => e?.status === "notGiven")
  const approvedReview = review.filter(e => e?.status === "approved")
  const rejectedReview = review.filter(e => e?.status === "rejected")
  const disputeReview = review.filter(e => e?.status === "dispute")

 const tabData = [
    { label: "All", filter: review },
    { label: "Active", filter: review.filter(e => e.status === "active") },
    { label: "inActive", filter: review.filter(e => e.status === "inActive") },
    { label: "Dispute", filter: review.filter(e => e.status === "dispute") },
  ]

  if (tabData[value]) {
    tabData[value].filter.map((e, i) =>
      rows.push({
        reviewId: e?._id,
        srNo: i + 1,
        guestName: e?.guestId?.firstName,
        hostName: e?.hostId?.firstName,
        status:
          e?.status === "notGiven" ? (
            <span className="badge bg-warning">Not Given</span>
          ) : e?.status === "active" || e?.status === "approved" ? (
            <span
              style={{
                textTransform: "capitalize",
              }}
              className="badge bg-success"
            >
              {e?.status}
            </span>
          ) : (
            <span
              style={{
                textTransform: "capitalize",
              }}
              className="badge bg-danger"
            >
              {e?.status}
            </span>
          ),
      })
    )
  }
  const myAction = params => {
    return (
      <>
        <Link to={`/triptrader/reviewedit/${params.reviewId}`}>
          <Tooltip title="Edit Reviews">
            <EditLocationAltIcon />
          </Tooltip>
        </Link>

        <Link to={`/triptrader/reviewdetail/${params.reviewId}`}>
          <Tooltip title="View Reviews">
            <VisibilityOutlinedIcon />
          </Tooltip>
        </Link>
      </>
    )
  }
  const columns = [
    {
      title: "Sr .No",
      field: "srNo",
    },
    {
      title: "Guest Name",
      field: "guestName",
    },
    {
      title: "Host Name",
      field: "hostName",
    },
    {
      title: "Status",
      field: "status",
    },
    {
      title: "Action",
      field: "Action",
      render: myAction,
    },
  ]

  useEffect(() => {
    getAllReview()
  }, [])
  const breadcrumbItems = [
    { title: "Dashboard", path: "/triptrader/dashboard" },
    { title: "Reviews", path: "#" },
  ]
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Manage Review| Trip Traders</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <Breadcrumbs breadcrumbItems={breadcrumbItems} />

                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active"></li>
                </ol>
              </Col>
            </Row>
          </div>
          <Row>
            <Col xl={4} md={6}>
              <Card
                className="mini-stat text-white"
                style={{ backgroundColor: "#283c2e" }}
              >
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon1} alt="" />
                    </div>
                    <h5 className="font-size-14 text-uppercase mt-0">
                      Total Reviews
                    </h5>
                    <h4 className="fw-medium font-size-24">{review.length} </h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4} md={6}>
              <Card
                className="mini-stat text-white"
                style={{ backgroundColor: "#283c2e" }}
              >
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon2} alt="" />
                    </div>
                    <h5 className="font-size-14 text-uppercase mt-0">
                      Active Reviews
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      {ActiveReview?.length}{" "}
                    </h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4} md={6}>
              <Card
                className="mini-stat text-white"
                style={{ backgroundColor: "#283c2e" }}
              >
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon3} alt="" />
                    </div>
                    <h5 className="font-size-15 text-uppercase mt-0">
                      Approved Reviews
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      {approvedReview.length}{" "}
                    </h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xl={4} md={6}>
              <Card
                className="mini-stat text-white"
                style={{ backgroundColor: "#283c2e" }}
              >
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon4} alt="" />
                    </div>
                    <h5 className="font-size-14 text-uppercase mt-0 ">
                      Rejected Reviews
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      {rejectedReview.length}
                    </h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4} md={6}>
              <Card
                className="mini-stat text-white"
                style={{ backgroundColor: "#283c2e" }}
              >
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={capture} alt="" />
                    </div>
                    <h5 className="font-size-14 text-uppercase mt-0 ">
                      Dispute Reviews
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      {disputeReview.length}
                    </h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4} md={6}>
              <Card
                className="mini-stat text-white"
                style={{ backgroundColor: "#283c2e" }}
              >
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={Not} alt="" />
                    </div>
                    <h5 className="font-size-14 text-uppercase mt-0 ">
                      NOTGIVEN Reviews
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      {notGivenReview.length}
                    </h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {loading ? (
            <CircularProgress />
          ) : (
            <Grid
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                overFlow: "scroll !important",
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="All" {...a11yProps(0)} />
                <Tab label="Active" {...a11yProps(1)} />
                <Tab label="inActive" {...a11yProps(2)} />
                <Tab label="Disputed" {...a11yProps(0)} />
              </Tabs>
              <TabPanel value={value} index={0}>
                <SearchTable columns={columns} data={rows} />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <SearchTable columns={columns} data={rows} />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <SearchTable columns={columns} data={rows} />
              </TabPanel>
              <TabPanel value={value} index={3}>
                <SearchTable columns={columns} data={rows} />
              </TabPanel>
            </Grid>
          )}
          <ToastContainer />
        </Container>
      </div>
    </React.Fragment>
  )
}
